export default __webpack_public_path__ + "static/media/Word-personaje-02.76f57b4c.png";